import { Button } from '@chakra-ui/react';
import { useGlobalContext } from 'GlobalContext';
import { FaRegTrashAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { removeContractService } from 'services/contract';
import { Mixpanel } from 'services/mixpanel';
import { AlertButtonOutput } from 'shared/components/Alert';
import { Product } from 'shared/models/product';
import { useFinancialContext } from '../../FinancialContext';
interface DeleteServiceButtonProps {
  loading?: boolean;
  service: Product;
}
const DeleteServiceButton = ({
  loading,
  service,
}: DeleteServiceButtonProps) => {
  const { alertController } = useGlobalContext();
  const { displayedContract: selectedContract, reloadContracts } =
    useFinancialContext();
  const deleteAlertButtonText = 'Sim, quero excluir';
  const changeAlertButtonState = (
    stt: boolean,
    alertButtonOutput: AlertButtonOutput,
  ) => {
    alertButtonOutput.clickedButton.disabled = stt;
    alertButtonOutput.clickedButton.text = stt
      ? 'Excluindo...'
      : deleteAlertButtonText;
    alertButtonOutput.atualizeStateButton(alertButtonOutput.clickedButton);
  };
  const deleteServiceRequest = (alertButtonOutput: AlertButtonOutput) => {
    if (
      selectedContract != undefined &&
      selectedContract?.products.length > 1 &&
      service.id != undefined
    ) {
      changeAlertButtonState(true, alertButtonOutput);
      Mixpanel.track('customers-financial-deleted-service');
      removeContractService(selectedContract.id!, service.id)
        .then(() => {
          changeAlertButtonState(false, alertButtonOutput);
          alertButtonOutput.close();
          toast.success('Serviço removido com sucesso');
          reloadContracts(false, selectedContract);
        })
        .catch((e: AxiosError) => {
          changeAlertButtonState(false, alertButtonOutput);
          alertButtonOutput.close();
          toast.error('Não foi possível remover o serviço');
          console.error(
            'Não foi possível remover o serviço',
            e?.response?.data
              ? JSON.stringify(e?.response?.data, null, 2)
              : JSON.stringify(e?.response, null, 2),
          );
        });
    } else {
      return toast.error(
        'Não foi possível remover o plano. É obrigatório ter no mínimo 1 serviço no contrato!',
      );
    }
  };
  const confirmAction = (
    onConfirm: (alertButtonOutput: AlertButtonOutput) => void,
  ) => {
    alertController?.showAlert({
      title: 'Você tem certeza que quer excluir o serviço?',
      message: 'O valor deixará de somar na fatura do cliente.',
      buttons: [
        {
          text: deleteAlertButtonText,
          variant: 'emphasisDanger',
          preventClose: true,
          onClick: (alertButtonOutput) => onConfirm(alertButtonOutput),
        },
        {
          text: 'Cancelar',
          variant: 'regular',
        },
      ],
    });
  };
  const handleDeleteClick = () => {
    confirmAction(deleteServiceRequest);
  };
  return (
    <Button
      isDisabled={loading}
      variant="planIcon"
      color="yRed.500"
      onClick={handleDeleteClick}
    >
      <FaRegTrashAlt></FaRegTrashAlt>
    </Button>
  );
};
export default DeleteServiceButton;
